<p-drawer
  [(visible)]="visible"
  position="right"
  [modal]="true"
  [closeOnEscape]="true"
  [dismissible]="true"
  styleClass="run-test-drawer"
  [style]="{ width: '480px' }">

  <ng-template pTemplate="header">
    <div class="rt-header">
      <h2 class="rt-title" i18n="@@runTest.title">Run Test</h2>
      <p class="rt-subtitle">{{ subtitle() }}</p>
    </div>
  </ng-template>

  <div class="rt-body" snAssistantSurface="runTest" surfaceTitle="Run test">
    <p-message severity="info" styleClass="rt-info">
      <span i18n="@@runTest.bulkHint">You can save and run tests in bulk. Check out the "Tests" tab in the agent's configuration.</span>
    </p-message>

    <div class="rt-field">
      <label for="rt-agent" i18n="@@runTest.selectAgent">Select Agent</label>
      @if (agentsLoading()) {
        <div class="rt-loading"><p-progressSpinner styleClass="rt-spinner"></p-progressSpinner></div>
      } @else {
        <p-select
          inputId="rt-agent"
          [options]="agentOptions()"
          [ngModel]="selectedAgentId()"
          (ngModelChange)="selectedAgentId.set($event)"
          [snAssistantId]="F.agent"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          filterBy="label"
          appendTo="body"
          i18n-placeholder="@@runTest.selectAgent.placeholder"
          placeholder="Select an agent..."
          styleClass="rt-select">
        </p-select>
      }
    </div>

    <div class="rt-checkbox">
      <p-checkbox
        inputId="rt-attach"
        [binary]="true"
        [ngModel]="attachToConfig()"
        (ngModelChange)="attachToConfig.set($event)"
        [snAssistantId]="F.attachToConfig">
      </p-checkbox>
      <label for="rt-attach" i18n="@@runTest.attach">Attach this test to the agent config</label>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="rt-footer" snAssistantSurface="runTest" surfaceTitle="Run test">
      <p-button
        i18n-label="@@common.cancel"
        label="Cancel"
        severity="secondary"
        [text]="true"
        [disabled]="isRunning()"
        (click)="cancel()">
      </p-button>
      <p-button
        i18n-label="@@runTest.title"
        label="Run Test"
        [icon]="isRunning() ? 'pi pi-spin pi-spinner' : 'pi pi-play'"
        [disabled]="!selectedAgentId() || isRunning()"
        [loading]="isRunning()"
        (click)="run()"
        snAssistantAction="run"
        actionDangerous
        actionHint="Runs this test against the chosen agent. It is a real conversation with the agent, so it takes time and costs money.">
      </p-button>
    </div>
  </ng-template>
</p-drawer>
